import React from 'react';
import { withNamespaces } from 'react-i18next';
import FontAwesome from 'react-fontawesome';
import LanguageMenu from '../languages/LanguageMenu';
import { Nav, NavItem } from 'react-bootstrap';
import { IndexLinkContainer } from 'react-router-bootstrap';
import queryString from 'query-string';

const isMobileMenu = window.innerWidth < 768;
const isActiveCentersLink = (match, location, referrerParam) => {
	if (!match) {
		return false;
	}
	const queryParams = queryString.parse(location.search);
	const { referrer } = location.state || queryParams;
	return referrer && referrer === referrerParam;
};

const AnonymousMenu = ({ t, bookingSearch, enableWorkshops, individualConsultationSearch, centers, languages, activeLanguage, onSelectLanguage }) => {
	return <div>
		<Nav pullRight>
			<IndexLinkContainer to={{ pathname: '/public/centers', state: { referrer: 'timetable' } }} isActive={(match, location) => isActiveCentersLink(match, location, 'timetable')}>
				<NavItem>{t('FO_PublicMenu_Book')}</NavItem>
			</IndexLinkContainer>
			{enableWorkshops && centers && centers.some(c => c.isWorkshops) && <IndexLinkContainer to={{ pathname: '/public/centers', state: { referrer: 'workshops' } }} isActive={(match, location) => isActiveCentersLink(match, location, 'workshops')}>
				<NavItem>{t('FO_PublicMenu_Workshops')}</NavItem>
			</IndexLinkContainer>}
			{/*<IndexLinkContainer to={`/public/timetable${bookingSearch}`}><NavItem>{t('FO_PublicMenu_Book')}</NavItem></IndexLinkContainer>*/}
			{centers && centers.some(c => c.isIndividualConsultation) && <IndexLinkContainer to={`/public/individual-consultations${individualConsultationSearch}`}><NavItem>{t('FO_PublicMenu_IndividualConsultations')}</NavItem></IndexLinkContainer>}
			<IndexLinkContainer to='/login'><NavItem><FontAwesome name='sign-in' /> {t('FO_Login_Login')}</NavItem></IndexLinkContainer>
			{languages.length > 1 && <LanguageMenu isMobileMenu={isMobileMenu} languages={languages} activeLanguage={activeLanguage} onSelectLanguage={onSelectLanguage} />}
			{languages.length === 1 && activeLanguage && <NavItem><img src={require(`../../theme/images/lang/${activeLanguage.image}`)} /></NavItem>}
		</Nav>
	</div>;
};

export default withNamespaces()(AnonymousMenu);